import { Link } from "react-router-dom";

interface RelatedMiniCardProps {
  to: string;
  cover: string;
  title: string;
  meta: string;
}

export default function RelatedMiniCard({ to, cover, title, meta }: RelatedMiniCardProps) {
  return (
    <Link
      to={to}
      className="group flex items-center gap-3 rounded-md p-2 hover:bg-background-100 transition-colors cursor-pointer"
    >
      <div className="w-12 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={cover}
          alt={title}
          title={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0">
        <h4 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h4>
        <p className="mt-1 text-xs text-foreground-500 truncate">{meta}</p>
      </div>
    </Link>
  );
}